import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Jumbotron,
  Button,
  CardImg,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  ModalFooter
} from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import ForCompaniesQuestionForm from "../AboutUsPage/QuestionForm/ForCompaniesQuestionForm";
import Academy from "./AcademyComponent/academyComponent";
import handleValidation from "../Validation";

import "./style.css";
import { Helmet } from "react-helmet";
class CompaniesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      fullName: "",
      email: "",
      phoneNumber: "",
      errors: {},
      errorsdiv: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value,
      contact: this.refs.contact.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] === true) {
      document.getElementById("companies").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("companies").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="all-pages">
            <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <Jumbotron className="jumbos for-companies-jumbo text-left">
          <Row>
            <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 2 }}>
              <h1 className="mt-5 mb-4">Build Your Talent</h1>
              <p className="mb-5">
                Do you update the skills of your team as often as you update
                software? At Lighthouse, we understand that upskilling your
                people is just as important as upgrading your software. We have
                customized training programs available for your company and your
                teams. From short training programs to full day trainings, let
                us help your team build skills that keep your company relevant,
                forever!
              </p>
              {/* eslint-disable-next-line */}
              <Button
                style={{ boxShadow: "2px 3px 4px black" }}
                className="course-hero-apply"
                onClick={this.toggle}
                className="courses-button"
              >
                {this.props.buttonLabel} Team Up With Us
              </Button>
              <Modal
                style={{ backGround: "black" }}
                isOpen={this.state.modal}
                toggle={this.toggle}
                className={this.props.className}
              >
                <ModalHeader
                  style={{ backgroundColor: "#26272d", color: "white" }}
                  toggle={this.toggle}
                >
                  Team Up With Us
                </ModalHeader>

                <form
                  id="companies"
                  action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                  method="POST"
                  onSubmit={this.submitDetails.bind(this)}
                >
                  <select
                    style={{ visibility: "hidden" }}
                    id="lead_source"
                    name="lead_source"
                  >
                    <option value="Website">Website</option>
                  </select>
                  <input type="hidden" name="oid" value="00D3i000000GUvA" />
                  <input type="hidden" name="lead_source" value="Website" />
                  <input
                    type="hidden"
                    name="00N3i00000Bm5C9"
                    value="Companies_website_v1"
                  />
                  <input
                    type="hidden"
                    name="retURL"
                    value="https://atlighthouse.com/thank-you"
                  />

                  <ModalBody>
                    <Row>
                      <Col sm={{ size: 12 }}>
                        <FormGroup>
                          <Label for="exampleName">Name</Label>
                          <input
                            id="first_name"
                            maxLength="60"
                            name="first_name"
                            size="20"
                            type="text"
                            ref="first_name"
                            className="apply-now-inputs form-control"
                          />
                          {this.state.errorsdiv === true ? (
                            <span className="error">
                              {this.state.errors["first_name"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={{ size: 12 }}>
                        <FormGroup>
                          <Label for="exampleEmail">Email</Label>
                          <input
                            id="email"
                            maxLength="80"
                            name="email"
                            size="20"
                            type="text"
                            className="apply-now-inputs form-control"
                            ref="email"
                          />
                          {this.state.errorsdiv === true ? (
                            <span className="error">
                              {this.state.errors["email"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={{ size: 12 }}>
                        <FormGroup>
                          <Label for="examplePhoneNumber">Phone Number</Label>
                          <input
                            id="contact"
                            maxLength="80"
                            minLength="10"
                            name="phone"
                            size="20"
                            type="text"
                            ref="contact"
                            className="apply-now-inputs form-control"
                          />
                          {this.state.errorsdiv === true ? (
                            <span className="error">
                              {this.state.errors["contact"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <input
                      type="submit"
                      name="submit"
                      className="courses-button btn-secondary"
                    />
                  </ModalBody>
                </form>

                <ModalFooter>
                  <Row>
                    <Col sm={{ size: 12 }}>
                      <p style={{ color: "grey" }}>
                        <i>
                          By providing your email, you agree to our{" "}
                          <u>
                            <Link
                              style={{ color: "grey" }}
                              to="/privacy-policy"
                            >
                              privacy policy
                            </Link>
                          </u>{" "}
                          and{" "}
                          <u>
                            <Link
                              style={{ color: "grey" }}
                              to="/terms-and-conditions"
                            >
                              terms and conditions
                            </Link>
                          </u>
                        </i>
                        .
                      </p>
                    </Col>
                  </Row>
                </ModalFooter>
              </Modal>
            </Col>
          </Row>
        </Jumbotron>

        <Academy heading={"World-Class Programs For Your Teams"} />

        <Container>
          {/* <Row>
              <Col> */}
          <Row className="justify-content-center pb-2">
            <Col sm={{ size: 11 }} md={{ size: 11 }} lg={{ size: 9 }}>
              <div className="position-relative">
                <h1 className="fc-line text-center mt-5 mb-3 pb-2">
                  How We Help You Stay Relevant, Forever.
                </h1>
              </div>
              {/* <hr className="heading-underline mb-5" /> */}
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={{ size: 12 }} lg={{ size: 3 }}>
              <Row className="justify-content-center">
                <Col
                  xs={{ size: 2 }}
                  md={{ size: 1 }}
                  lg={{ size: 3 }}
                  className="icon-container"
                >
                  <CardImg
                    className="companies-icons"
                    top
                    width="100%"
                    src="img/assessment-icon-v2.png"
                    alt="Card image cap"
                  />
                </Col>
                <Col xs={{ size: 5 }} lg={{ size: 7 }}>
                  <h3 className="left-align"> Assessment</h3>
                  <p className="left-align ">
                    Ensuring your team gets what is needed
                  </p>
                </Col>
              </Row>
            </Col>

            <Col xs={{ size: 12 }} lg={{ size: 3 }}>
              <Row className="justify-content-center">
                <Col
                  xs={{ size: 2 }}
                  md={{ size: 1 }}
                  lg={{ size: 3 }}
                  className="icon-container"
                >
                  <CardImg
                    className="companies-icons"
                    top
                    width="100%"
                    src="img/upskilling-icon-v2.png"
                    alt="Card image cap"
                  />
                </Col>
                <Col xs={{ size: 5 }} lg={{ size: 7 }}>
                  <h3 className="left-align"> Upskilling</h3>
                  <p className="left-align ">
                    Stay relevant and adaptable in the tech sphere
                  </p>
                </Col>
              </Row>
            </Col>

            <Col xs={{ size: 12 }} lg={{ size: 3 }}>
              <Row className="justify-content-center">
                <Col
                  xs={{ size: 2 }}
                  md={{ size: 1 }}
                  lg={{ size: 3 }}
                  className="icon-container"
                >
                  <CardImg
                    className="companies-icons"
                    top
                    width="100%"
                    src="img/onboarding-icon-v2.png"
                    alt="Card image cap"
                  />
                </Col>
                <Col xs={{ size: 5 }} lg={{ size: 7 }}>
                  <h3 className="left-align"> Onboarding</h3>
                  <p className="left-align ">
                    Implement new skills with efficiency
                  </p>
                </Col>
              </Row>
            </Col>
            <Col xs={{ size: 12 }} lg={{ size: 3 }}>
              <Row className="justify-content-center">
                <Col
                  xs={{ size: 2 }}
                  md={{ size: 1 }}
                  lg={{ size: 3 }}
                  className="icon-container"
                >
                  <CardImg
                    className="companies-icons"
                    top
                    width="100%"
                    src="img/reskilling-icon-v2.png"
                    alt="Card image cap"
                  />
                </Col>
                <Col xs={{ size: 5 }} lg={{ size: 7 }}>
                  <h3 className="left-align"> Reskilling</h3>
                  <p className="left-align ">
                    Unlearn to relearn new methodology
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <div className="section-padding dark-background">
          <Container className="px-4">
            <Row className="justify-content-center">
              <Col sm={{ size: 11 }} md={{ size: 11 }} lg={{ size: 9 }}>
                <h1 className="mt-5 mb-3 text-center">
                  Time Is Valuable. We're Here To <br />
                  Help You Save Time
                </h1>
                <hr className="heading-underline mb-5" />
              </Col>
            </Row>
            <Row className="justify-content-center text-md-left text-center">
              <Col xs={{ size: 11, order: 2 }} sm={{ size: 8, order: 1 }}>
                <Row>
                  <Col className="icon-container" sm={{ size: 6 }}>
                    <div className="position-relative ">
                      <h3 className="thin-yellow-line text-left mb-sm-4  ">
                        Talent Marketplace
                      </h3>{" "}
                    </div>
                    {/* <hr className="card-line mt-1" /> */}
                    <p className="text-left mb-sm-3 ">
                      We create a pipeline between our students and your company
                      so you can get the talent you need.
                    </p>{" "}
                  </Col>
                  <Col sm="6">
                    <div className="position-relative">
                      <h3 className="thin-yellow-line text-left mb-sm-3">
                        Benchmark Productivity
                      </h3>{" "}
                    </div>
                    {/* <hr className="card-line mt-1" /> */}
                    <p className="text-left mb-sm-3">
                      Through coding challenges and problem-solving exercises,
                      we ensure that your people can go beyond basic course
                      materials and advance on their own with a growth mindset.
                    </p>{" "}
                  </Col>
                </Row>
                <Row className="how-fast-row2">
                  <Col className="icon-container" sm={{ size: 6 }}>
                    <div className="position-relative">
                      <h3 className="thin-yellow-line text-left mb-sm-3 ">
                        Relevant Curriculum
                      </h3>{" "}
                    </div>
                    {/* <hr className="card-line mt-1" /> */}
                    <p className="text-left mb-sm-3">
                      Our curriculum is always evolving to stay aligned with the
                      current market so that your team can be at the forefront
                      of technology.
                    </p>{" "}
                  </Col>
                  <Col sm="6">
                    <div className="position-relative">
                      <h3 className="thin-yellow-line text-left mb-sm-3">
                        Tech Partnership
                      </h3>{" "}
                    </div>
                    {/* <hr className="card-line mt-1" /> */}
                    <p className="text-left mb-sm-3">
                      We partner with the top tech companies to ensure your team
                      receives relevant training on concurrent trends and
                      changes in the industry.
                    </p>{" "}
                  </Col>
                </Row>
              </Col>
              <Col
                xs={{ size: 12, order: 1 }}
                sm={{ size: 4, order: 2 }}
                className="pb-5"
              >
                <CardImg
                  top
                  width="100%"
                  src="img/employee-upskill-v2.png"
                  alt="Card image cap"
                />
              </Col>
            </Row>
          </Container>
        </div>

        <div className="section-padding">
          <Container>
            <Row className="justify-content-center">
              <Col sm={{ size: 12 }}>
                <h1 className="mt-5 mb-3 text-center">Upgrade Fast, Now.</h1>
                <hr className="heading-underline mb-5" />
              </Col>
            </Row>
            <Row>
              <Col sm={{ size: 10, offset: 1 }}>
                <p className="mb-5">
                  We offer a diverse range of courses that are relevant to
                  today’s industry. Our certifications help increase the market
                  value of your employees and teams quickly and effectively.
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={{ size: 12 }} md={{ size: 6 }} lg={{ size: 3 }}>
                <Card className="clear-card left-align">
                  <CardImg
                    top
                    width="100%"
                    src="img/full-stack-icon-v2.png"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <h3>Web Development</h3>
                    <hr
                      className="card-line mt-1"
                      style={{ marginRight: "55%" }}
                    />
                    <p>
                      This course offers the ability to learn about the tools,
                      technologies and processes that current developers use.
                      <br />
                      <br />
                      HTML, CSS, Java, Ruby on Rails, Angular and JavaScript.
                    </p>
                    <Link to="/browse" style={{ color: "white" }}>
                      <h5 className="learn-more1">
                        Learn more
                        <FontAwesome
                          className="arrow-right"
                          name="arrow-right"
                          style={{ marginLeft: ".5rem" }}
                        />
                      </h5>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={{ size: 12 }} md={{ size: 6 }} lg={{ size: 3 }}>
                <Card className="clear-card left-align">
                  <CardImg
                    top
                    width="100%"
                    src="img/exp-design-icon-v2.png"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <h3>Design</h3>
                    <hr
                      className="card-line mt-1"
                      style={{ marginRight: "55%" }}
                    />
                    <p>
                      Design Thinking has become an essential part of how people
                      interface with products today. This course teaches
                      application of design concepts to approach problems
                      strategically and efficiently, helping your team create
                      the next wave of digital products and applications.
                    </p>
                    <Link to="/browse" style={{ color: "white" }}>
                      <h5 className="learn-more1">
                        Learn more
                        <FontAwesome
                          className="arrow-right"
                          name="arrow-right"
                          style={{ marginLeft: ".5rem" }}
                        />
                      </h5>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={{ size: 12 }} md={{ size: 6 }} lg={{ size: 3 }}>
                <Card className="clear-card left-align">
                  <CardImg
                    top
                    width="100%"
                    src="img/data-science-icon-v2.png"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <h3>Data</h3>
                    <hr
                      className="card-line mt-1"
                      style={{ marginRight: "55%" }}
                    />
                    <p>
                      A hands-on approach to the fundamental modeling techniques
                      and machine learning algorithms that enable you to build
                      models of real world data and test their validity.
                      Consists of statistical analysis of data, programming,
                      machine learning, Natural Language Processing, Data
                      Engineering and Data Visualization Tools.
                    </p>
                    <Link to="/browse" style={{ color: "white" }}>
                      <h5 className="learn-more1">
                        Learn more
                        <FontAwesome
                          className="arrow-right"
                          name="arrow-right"
                          style={{ marginLeft: ".5rem" }}
                        />
                      </h5>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={{ size: 12 }} md={{ size: 6 }} lg={{ size: 3 }}>
                <Card className="clear-card left-align">
                  <CardImg
                    top
                    width="100%"
                    src="img/digital-marketing-icon-v2.png"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <h3>Digital Marketing</h3>
                    <hr
                      className="card-line mt-1"
                      style={{ marginRight: "55%" }}
                    />
                    <p>
                      This course focuses on developing skills in digital
                      advertising, content creation and strategy, social media,
                      SEO, and more. Interact with professional marketers who
                      cover real world strategies and discuss case studies that
                      highlight the changing trends in marketing.
                    </p>
                    <Link to="/browse" style={{ color: "white" }}>
                      <h5 className="learn-more1">
                        Learn more
                        <FontAwesome
                          className="arrow-right"
                          name="arrow-right"
                          style={{ marginLeft: ".5rem" }}
                        />
                      </h5>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <ForCompaniesQuestionForm
          title={"Ready To Team Up?"}
          textTitle={"We’d love to help your team!"}
          text={
            "Schedule a call with one of our advisors. From helping your team upskill to developing a curriculum to fit your company, we’re here to help!"
          }
          formValue={"Companies_website_v1"}
        />
      </div>
    );
  }
}

export default withRouter(CompaniesPage);
